import { useMemo } from 'react';
import { GameInviteFilters } from '.';
import { GameCreateFen } from '../../../../store/models';

export const useGameFilters = <T extends any>(games: T[], filters: GameInviteFilters) => {
    return useMemo(() => {
        let filteredGames = games;

        const FEN_TYPE_LABELS = {
            [GameCreateFen.classic]: 'Classic',
            [GameCreateFen.nineHundredSixty]: '960',
        };

        const getSelected = (obj) =>
            Object.entries(obj)
                .filter(([, value]) => value)
                .map(([key]) => key);

        const selectedBets = getSelected(filters.bet);
        if (selectedBets.length > 0) {
            filteredGames = filteredGames.filter((game: any) => {
                const bet = game.bet || game.details?.bank;
                return bet != null && selectedBets.includes(String(bet));
            });
        }

        const selectedTimes = getSelected(filters.time);
        if (selectedTimes.length > 0) {
            filteredGames = filteredGames.filter((game: any) => {
                const time = game.time;
                return time != null && selectedTimes.includes(String(time));
            });
        }

        const selectedTypes = getSelected(filters.type); 
        if (selectedTypes.length > 0) {
            filteredGames = filteredGames.filter((game: any) => {
                const fenType = game.fenType ?? game.details?.fenType;
                const label = FEN_TYPE_LABELS[fenType];
                return label && selectedTypes.includes(label);
            });
        }

        const selectedGameModes = getSelected(filters.gameMode);
        if (selectedGameModes.length > 0) {
            filteredGames = filteredGames.filter((game: any) => {
                const gameType = game.type || game.details?.type;
                return gameType != null && selectedGameModes.includes(String(gameType));
            });
        }

        const selectedMatches = getSelected(filters.matches);
        if (selectedMatches.length > 0) {
            filteredGames = filteredGames.filter((game: any) => {
                const matchCount = game.matchCount || game.details?.gameCount;
                return matchCount != null && selectedMatches.includes(String(matchCount));
            });
        }

        return filteredGames;
    }, [games, filters]);
};